import React from 'react';
import Tippy from '@tippyjs/react';

import AuthorAvatar from '../page/AuthorAvatar';
import PageCategoryTitle from '../page/PageCategoryTitle';

import { CategoryOptionDropdown } from './CategoryActions';

import useCategories from '../../hooks/useCategories';

const CategoryVisibility = ({ category }) => {
    const { visibility_text, visibility_description } = category;

    return (
        <div className="flex-none flex">
            <Tippy content={visibility_description} placement="bottom">
                <div className="page-visibility">
                    { visibility_text }
                </div>
            </Tippy>
            <div className="flex-none">
                <CategoryOptionDropdown category={category} />
            </div>
        </div>
    );
};

const LoadingHeader = () => (
    <div className="page-top flex-none mb3">
        <div className="flex-auto flex gray" />
        <div className="flex-none flex no-select mr1 sm-show" style={{ marginTop: 4 }} />
        <div className="flex-none flex no-select" />
        <div className="flex-none no-select" />
    </div>
);

const CategoryHeader = ({ category }) => {
    const {
        id: category_id, folder_id, parents = [], owner_ids = [],
    } = category;

    const categories = useCategories();
    if (!categories) return <LoadingHeader />;

    return (
        <div className="page-top flex-none">
            <div className="flex-auto flex gray">
                { category_id && <PageCategoryTitle categoryId={category_id} folderId={folder_id} parents={parents} /> }
            </div>
            <div className="flex-none flex">
                <div className="flex-none mr1 sm-show category-owners" style={{ paddingTop: 3, paddingBottom: 3 }}>
                    { owner_ids.map(ownerId => <AuthorAvatar userId={ownerId} customClass="avatar right" customLinkClass="owner__avatar" key={`owner-${ownerId}`} />) }
                </div>
                {window.loggedIn && <CategoryVisibility category={category} /> }
            </div>
        </div>
    );
};

export default CategoryHeader;
